export const PRELOADER = 'PRELOADER';
export const PRELOADER_SUCCESS = 'PRELOADER_SUCCESS';

export const preloaderShow = () => ({
    type: PRELOADER,
    payload: {
        showPreloader: true,
    }
});

export const preloaderHide = () => ({
    type: PRELOADER_SUCCESS,
    payload: null
});